import React, {useState, useEffect, useRef} from 'react'
import _ from 'underscore'

import {Link, Outlet} from 'react-router-dom'
import PaginationItem from '@mui/material/PaginationItem'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'

import './MyTable.css'
import {Pagination, Popover} from '@mui/material'
import {MAX_URL_LENGTH} from '../../pages/subjects/SubjectEdit'
import {CreateIndicator, Filter, RightSide, SortContainer} from "../../pages/subjects/Subject.style";
import CustomSearchInput from "../customInput/searchInput";
import FilterListIcon from "@mui/icons-material/FilterList";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import {getSubjectId} from "../../pages/biomarkers/[id]/IndicatorsAndSignals";
import AddIcon from "@mui/icons-material/Add";
import {styled} from "styled-components";
import {TypographyPopover} from "../layouts/mainLayout/mainLayout.style";
import {ArrowBack} from "@mui/icons-material";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import http from '../../api/http';

function Searchify(props: any) {
    let {value, search, length} = props

    const getLocalizedValue = (val: any): string => {
        if (typeof val === 'string') {
            return val;
        }
        if (typeof val === 'object' && val !== null) {
            return val.en || val['en'] || Object.values(val)[0] || '';
        }
        return '';
    }

    const displayValue = getLocalizedValue(value);
    length = length || MAX_URL_LENGTH
    
    if (!search) {
        return (
            <>
                {displayValue?.slice(0, length)}
                {displayValue?.slice(length).length > 0 && '...'}
            </>
        )
    }
    let reg = new RegExp(search, 'gi')
    const highlightedValue = (displayValue || '').replace(
        reg,
        (it: any) => `<strong class="hover-search">${it}</strong>`
    )

    return <div dangerouslySetInnerHTML={{__html: highlightedValue}}></div>
}

const TableStyle = styled.div<{ hasdata: string }>`
  width: 100%;

  /* height: 600px; */
  /* min-height: 500px; */
  //overflow:scroll;

  ${({hasdata}) =>
    hasdata === 'true' && 'border: 1px solid var(--border-main, #ededed);'}

  table {
    /* height: 100%; */
    /* table-layout: fixed; */
    width: 100%;
    border: none;
    border-collapse: collapse;

    td {
      border: none;
      height: fit-content;
      p {
        /* word-wrap: break-word; */
      }
    }

  }
`

function Table(props: any) {
    let {
        Head,
        Body,
        EmptyItems,
        NothingFound,
        apiSearchFields,
        apiUrl,
        onChangeFilter,
        onFilter,
        onSearch,
        onRemove,
        filter,
    } = props

    let [stateItems, setItems] = useState([])
    let [stateTotal, setTotal] = useState(0)
    let {page, search, perPage} = filter || {}
    let reg = search ? new RegExp(search, 'i') : null

    page ??= 1

    useEffect(() => {
        if (!apiUrl) {
            return
        }


        const params = {
            search: filter.search || '',
            page: filter.page || page || 1,
            per_page: filter.perPage,
            sort: filter.sort || '_id',
            direction: filter.direction || 'desc',
            ...Object.fromEntries(
                (filter.apiSearchFileds || ['name']).map((field: any, index: number) => 
                    [`filters[${index}]`, field]
                )
            ),
            ...Object.fromEntries(
                Object.keys(filter.filter || {}).map(key => 
                    [`filter[${key}]`, filter.filter[key]]
                )
            )
        }

        console.log('Fetching URL:', apiUrl)
        console.log('Query params:', params)
        console.log('Current page:', filter.page || page || 1)
        
        http.get(apiUrl, params)
            .then((response: any) => {
                console.log('Response status:', response.status)
                const {data} = response.data
                console.log('API Response data:', data)
                console.log('API items:', data.items)
                console.log('API pagination:', data.pagination)
                setItems(data.items || [])
                // Используем pagination.pages если доступно, иначе total
                setTotal(data.pagination?.pages || data.total || 1)
            })
            .catch((error: any) => {
                console.error(
                    'There was a problem with the API request:',
                    error.message
                )
                console.error('Full error:', error)
                setItems([])
                setTotal(0)
            })
    }, [apiUrl, JSON.stringify(filter)])

    let items = apiUrl ? stateItems : props.items

    let filteredItems = items.filter(
        (it: any) => onFilter(it, filter.filter || {}) && (!search || onSearch(it, reg))
    )
    const startIndex = (page - 1) * perPage
    const endIndex = startIndex + perPage
    const visibleItems = apiUrl
        ? filteredItems
        : filteredItems
            .sort((item1: any, item2: any) => {
                let key = filter.sort || '_id'
                key = key === 'Number' ? '_id' : key === 'Name' ? 'name' : key;


                let gv = (v: any) => {
                   return v == +v ? +v : String(v || '').trim().toUpperCase();
                }
                let isMore = gv(item1[key]) > gv(item2[key])
                isMore = filter.direction === 'asc' ? isMore : !isMore
                return isMore ? 1 : -1
            })
            .slice(startIndex, endIndex)

    let total = apiUrl ? stateTotal : items.length

    console.log('Table debug - apiUrl:', apiUrl)
    console.log('Table debug - items:', items)
    console.log('Table debug - visibleItems:', visibleItems)
    console.log('Table debug - total:', total)
    console.log('Table debug - stateTotal:', stateTotal)

    if (!total) {
        return <EmptyItems></EmptyItems>
    }
    
    // Для API используем stateTotal, для локальных данных - filteredItems.length
    let count = apiUrl ? stateTotal : Math.ceil(filteredItems.length / perPage);
    console.log('Table debug - count:', count)
    console.log('Table debug - perPage:', perPage)
    
    const setFilter = props.onChangeFilter;

    return (
        <>
            <TableStyle hasdata={'true'}>
                <table border={1} data-animch>
                    <Head data-animch/>
                    {(visibleItems || []).map((it: any, ind: number) => (
                        <Body
                            connectIds={props?.connectIds}
                            signalSetsByCheckboxes={props?.signalSetsByCheckboxes}
                            key={ind}
                            item={it}
                            ind={ind}
                            search={search}
                            onConnect={props.onConnect}
                        />
                    ))}
                    {!visibleItems.length && (
                        <tbody>
                        <NothingFound/>
                        </tbody>
                    )}
                </table>
                {count > 1 && <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        borderTop: '1px solid #eee',
                        paddingTop: '10px',
                        marginTop: '20px',
                        width: '100%'
                    }}
                >

                    <Pagination
                        data-animch2={10}
                        page={page}
                        size='medium'
                        sx={{padding: '10px'}}
                        defaultValue={1}
                        count={count}
                        onChange={(_, newPage) => onChangeFilter({...filter, page: newPage})}
                    />

                </div>}
            </TableStyle>
        </>
    )
}

export const TableFilter = (props: any) => {
    props = props || {}
    let {
        filter, setFilter, name, url, sortArr = [
            {sort: 'Name', direction: 'asc'}, {sort: 'Name', direction: 'desc'},
            {sort: 'Number', direction: 'asc'}, {sort: 'Number', direction: 'desc'},

        ]
    } = props;
    const [specialAge, setSpecialAge] = useState('')
    const [specialKey, setSpecialKey] = useState('')
    const [isSearchOpen, setSearchOpen] = useState(false)
    const [isCustomFilter, setCustomFilter] = useState(false)
    const popoverEl = useRef(null)
    const customFilterEl = useRef(null)

    function onChangeSort(data: any) {
        let {direction, sort} = data;

        setFilter((prev: any) => ({
            ...prev,
            direction,
            sort
        }))
        setSearchOpen(false)

    }

    useEffect(() => {
        props.onChangeCustomFilter && props.onChangeCustomFilter({key: specialKey, age: specialAge})

    }, [specialKey, specialAge])


    let getName = (it: string) => {
        return {
            '': 'Unified',
            'w': 'Female',
            'w_white': 'White Female',
            'w_asian': 'Asian Female',
            'w_black': 'Black Female',
            'm': 'Male',
            'm_white': 'White Male',
            'm_asian': 'Asian Male',
            'm_black': 'Black Male',
            // 'w_white': 'White Female',
        }[it] || ''
    }

    let isEditor = (global as any)?.isEditor;

    return <>
        <RightSide data-animch={3} data-right-side>

            <div data-custom-inp-wrap>
                <CustomSearchInput
                    woValue={true}
                    data-custom-input-right-side
                    value={filter?.search}
                    preventReset={true}
                    handleChange={(search) =>
                        setFilter((prev: any) => ({...prev, search}))
                    }
                /></div>
    
            <SortContainer
                ref={popoverEl}
                onClick={() => {
                    setSearchOpen(!isSearchOpen)
                }}
                // selected={filter.sort}
            >
                {/*<p ref={popoverEl}>Sort</p>*/}
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <mask id="mask0_676_5682" style={{"maskType":"alpha"}} maskUnits="userSpaceOnUse" x="3" y="3" width="14" height="14">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.01076 3.17242C5.93704 3.20292 5.86798 3.24814 5.80806 3.30806L3.30806 5.80806C3.06398 6.05214 3.06398 6.44786 3.30806 6.69194C3.55214 6.93602 3.94786 6.93602 4.19194 6.69194L5.625 5.25888V16.25C5.625 16.5952 5.90482 16.875 6.25 16.875C6.59518 16.875 6.875 16.5952 6.875 16.25V5.25888L8.30806 6.69194C8.55214 6.93602 8.94786 6.93602 9.19194 6.69194C9.43602 6.44786 9.43602 6.05214 9.19194 5.80806L6.69194 3.30806C6.57884 3.19496 6.42259 3.125 6.25 3.125L6.01076 3.17242ZM10.8081 13.3081C11.0521 13.064 11.4479 13.064 11.6919 13.3081L13.125 14.7411V3.75C13.125 3.40482 13.4048 3.125 13.75 3.125C14.0952 3.125 14.375 3.40482 14.375 3.75V14.7411L15.8081 13.3081C16.0521 13.064 16.4479 13.064 16.6919 13.3081C16.936 13.5521 16.936 13.9479 16.6919 14.1919L14.1919 16.6919C14.132 16.7519 14.063 16.7971 13.9892 16.8276C13.9172 16.8574 13.8384 16.8742 13.7558 16.875C13.7538 16.875 13.7519 16.875 13.75 16.875C13.7481 16.875 13.7462 16.875 13.7442 16.875C13.6616 16.8742 13.5828 16.8574 13.5108 16.8276C13.437 16.7971 13.368 16.7519 13.3081 16.6919L10.8081 14.1919C10.564 13.9479 10.564 13.5521 10.8081 13.3081Z" fill="black"/>
                    </mask>
                    <g mask="url(#mask0_676_5682)">
                        <rect width="20" height="20" fill="#808080"/>
                    </g>
                </svg>
            </SortContainer>
            {props.onChangeCustomFilter && <span className={'customFilter'} ref={customFilterEl} onClick={() => {
                console.log("qqqqq isCustomFilter", isCustomFilter);
                setCustomFilter(!isCustomFilter)
            }}>
                {getName(specialKey)}{specialAge && <>: {specialAge || 'Default'}</>}
            </span>}
            <Popover
                id={'customFilter'}
                style={{marginLeft: '-200px'}}
                open={isCustomFilter}
                anchorEl={customFilterEl.current}
                onClose={() => {
                    setCustomFilter(false)
                }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
            >
                {([[''], ['w', 'w_white', 'w_asian', 'w_black'], ['m', 'm_white', 'm_asian', 'm_black']]).map((it: any, ind: number) => {
                    return <div key={'p' + ind}>
                        {ind > 0 && <div className={'smallHr'}></div>}
                        {(it || []).map((it: string, ind: number) => {
                            return (<>
                                    <TypographyPopover data-sort-item data-fade
                                                       className={'popoverItem'}
                                                       onClick={() => {
                                                           setCustomFilter(false)
                                                           setSpecialKey(it)
                                                       }}>
                                        {getName(it)}
                                    </TypographyPopover></>
                            )
                        })}
                    </div>


                })}
                <div className={'smallHr'}></div>
                <div style={{padding: '5px 0', marginTop: '-1px'}}>
                    <input value={specialAge}
                           className={'ageInput'}
                           type={"number"}
                           placeholder={'Specify Age'} onChange={(e) => {
                        setSpecialAge((e.target.value))
                        // props.onChangeCustomFilter({key: specialKey, age: specialAge})
                    }}/>
                </div>

            </Popover>
            <Popover
                id={'sorting'}
                open={isSearchOpen}
                anchorEl={popoverEl.current}
                onClose={() => {
                    setSearchOpen(false)
                }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                {(sortArr || []).map((it: any, ind: number) => {
                    return (<TypographyPopover
                        className={'popoverItem'}
                        data-sort-item sx={{py: 1, pr: 3, pl: 1}} data-fade onClick={() => {
                        onChangeSort(it)
                    }}>
                        <ArrowDownwardIcon style={{rotate: it.direction === 'desc' ? '0deg' : '180deg'}}/>
                        {it.sort}
                    </TypographyPopover>)
                })}


            </Popover>

            {!isEditor && <></>}
            {isEditor && <Link
                data-add-btn
                className={'btn'}
                to={url}
                style={{marginTop: '2px'}}
            >
                <AddIcon sx={{p: 0}} style={{width: '30px', height: '30px', marginTop: '-5px', marginLeft: '-5px'}}/>
                <div className="ib">{name}</div>
            </Link>}
        </RightSide></>
}

export {Searchify, Table}

export default Table
